"use client";

import { displayLabel } from "@/lib/display";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface Props {
  success: number | null | undefined;
  rejectReason: string | null | undefined;
  onClassify: () => void;
  loading: boolean;
}

export function OutcomePanel({ success, rejectReason, onClassify, loading }: Props) {
  const hasResult = success !== null && success !== undefined;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium">对话结果</h3>
        <Button variant="outline" size="sm" onClick={onClassify} disabled={loading}>
          {loading ? "分类中..." : hasResult ? "重新分类" : "分类"}
        </Button>
      </div>

      {!hasResult ? (
        <p className="text-sm text-muted-foreground">未执行</p>
      ) : success === 1 ? (
        <Badge variant="default" className="bg-green-600">成功</Badge>
      ) : (
        <div className="rounded-md bg-destructive/10 px-3 py-2.5 space-y-1.5">
          <Badge variant="destructive">失败</Badge>
          {rejectReason && (
            <p className="text-sm font-medium text-destructive">{displayLabel(rejectReason)}</p>
          )}
        </div>
      )}
    </div>
  );
}
